module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/admin/admin.component.scss
// module id = ./src/app/layout/admin/admin.component.scss
// module chunks = main